import './App.css';
import React from 'react';
import CryptoTracker from './CryptoTracker';
function App() {
  return (
  <>
  <div>
  <CryptoTracker/>
  </div>
  </>
  );
}

export default App;
